export const environment = {
  production: false,
  apiUrl: 'https://devapi.tests-psychotechniques.fr/api',
  frontUrl: 'https://dev.tests-psychotechniques.fr',
  getConfigInterval: 3600,
  amazonPayMerchantId: 'A2QXGRF44E3PSV',
  amazonPayClientId: 'amzn1.application-oa2-client.88ecf68f97d74afa9433c39d10395667',
};